module.exports = __webpack_public_path__ + "static/media/card-ECA.6cabc994.svg";